var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkmark-fill"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-23",
    fill: "#22CDC8",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6275,8.025 L3,6.4425 L4.095,5.37 L5.175,6.4275 L7.905,3.75 L9,4.8225 L5.715,8.025 C5.57340453,8.17404811 5.3768336,8.25843835 5.17125,8.25843835 C4.9656664,8.25843835 4.76909547,8.17404811 4.6275,8.025 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkFill);
export default __webpack_public_path__ + "static/media/checkmark-fill.8e407ad7801580edc4ba299db44252db.svg";
export { ForwardRef as ReactComponent };